<template>
	<div>
		<h4>Exportation des fichiers</h4>
		<el-button @click.native.prevent="createXlsx()" type="success" icon="el-icon-download" round>Fichier au format .xlsx</el-button>
	</div>
</template>

<script>
import scriptQse from '../../../script/script-qse.js';

export default {
    data() {
        return {}
    },
    methods: {
    	createXlsx() {
        	scriptQse.createXlsx.call(this, this.axios)
    	}
	}
}
</script>